import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useAdminAuthStore } from './store/adminAuth'
import { installSessionRecheck } from './auth/session-lifecycle.mjs'
import './styles/main.css'
import './styles/admin-theme.css'
import './styles/public-catalog-theme.css'
import { installAppVersionRefresh } from './utils/appVersion'

const pinia = createPinia()
createApp(App).use(pinia).use(router).mount('#app')
const stopSessionRecheck = installSessionRecheck({ auth: useAdminAuthStore(pinia), router, changeKey: 'autosquare_openinfo_session_changed' })
if (module.hot) module.hot.dispose(stopSessionRecheck)

installAppVersionRefresh()
